const cloneDeep = (data) => {
  if (Array.isArray(data) || Object.prototype.toString.call(data) === '[object Object]') {
    const copy = Array.isArray(data) ? [] : {}
    for (const key in data) {
      if (Array.isArray(data[key]) || Object.prototype.toString.call(data[key]) === '[object Object]') {
        copy[key] = cloneDeep(data[key])
      } else {
        copy[key] = data[key]
      }
    }
    return copy
  } else {
    return data
  }
}

export default cloneDeep
